export default {
	url: 'https://rentals215.com/'
}
